<template>
	<v-dialog v-model="isVisible" persistent max-width="750">
		<p-card class="tw-p-none overflow-hidden">
			<p-header-dialog :negative-margin="false" @closeClicked="close()">
				Agregar Postulante:
			</p-header-dialog>
			<section class="form-applicant tw-flex tw-flex-col tw-justify-between tw-gap-3 tw-p-6">
				<v-layout row class="tw-flex tw-justify-between tw-items-center">
					<v-flex xs10>
						<v-layout row class="tw-flex tw-justify-between tw-items-center tw-mb-5 tw-gap-7">
							<v-flex xs2>
								<label :style="`color:${$appColors.info}; font-weight: bold;`">Nombres:</label>
							</v-flex>
							<v-flex xs10>
								<input
									class="form-applicant-input"
									type="text"
									:disabled="editApplicant"
									v-model="applicant.name">
							</v-flex>
						</v-layout>
						<v-layout row class="tw-flex tw-justify-between tw-items-center tw-gap-7">
							<v-flex xs2>
								<label :style="`color:${$appColors.info}; font-weight: bold;`">Apellidos:</label>
							</v-flex>
							<v-flex xs10>
								<input
									class="form-applicant-input"
									type="text"
									:disabled="editApplicant"
									v-model="applicant.lastName">
							</v-flex>
						</v-layout>
					</v-flex>
					<v-flex xs2 class="tw-flex tw-justify-end">
						<div class="wrapper-user-image">
							<div class="wrapper-user">
								<img 
									:src="applicant.urlImage" 
									alt="user"
									height="100%"
									width="100%">
							</div>
							<div class="wrapper-camera">
								<load-file
									:show-input="false"
									:code="codeCompany"
									:disabled="!applicant.documentNumber"
									:name-file="applicant.documentNumber"
									icon="camera_alt"
									color="white"
									class-btn="circle-btn"
									@input="getImage">
								</load-file>
							</div>
						</div>
					</v-flex>
				</v-layout>
				<v-layout row class="tw-flex tw-justify-between tw-items-center">
					
				</v-layout>
				<v-layout row class="tw-flex tw-justify-between tw-items-center">
					<v-flex xs2>
						<label :style="`color:${$appColors.info}; font-weight: bold;`">Tipo de Documento:</label>
					</v-flex>
					<v-flex xs4>
						<v-select
							solo
							class="custom-select-form-v2"
							:items="typeDocuments"
							item-text="name"
							item-value="id"
							:disabled="editApplicant"
							v-model="applicant.typeDocument"
						></v-select>
					</v-flex>
					<v-flex xs2 class="tw-pl-2">
						<label :style="`color:${$appColors.info}; font-weight: bold;`">Nro. Documento:</label>
					</v-flex>
					<v-flex xs4>
						<input
							class="form-applicant-input"
							type="number"
							:disabled="editApplicant"
							v-model="applicant.documentNumber">
					</v-flex>
				</v-layout>
				<v-layout row class="tw-flex tw-justify-between tw-items-center">
					<v-flex xs2>
						<label :style="`color:${$appColors.info}; font-weight: bold;`">Teléfono:</label>
					</v-flex>
					<v-flex xs4>
						<input
							class="form-applicant-input"
							type="number"
							:disabled="editApplicant"
							v-model="applicant.phone">
					</v-flex>
					<v-flex xs2 class="tw-pl-2">
						<label :style="`color:${$appColors.info}; font-weight: bold;`">Correo:</label>
					</v-flex>
					<v-flex xs4>
						<input
							class="form-applicant-input"
							type="text"
							:disabled="editApplicant"
							v-model="applicant.email">
					</v-flex>
				</v-layout>
				<v-layout row class="tw-flex tw-justify-between tw-items-center">
					<v-flex xs2>
						<label :style="`color:${$appColors.info}; font-weight: bold;`">Género:</label>
					</v-flex>
					<v-flex xs4>
						<v-select
							solo
							class="custom-select-form-v2"
							:items="gender"
							item-text="name"
							item-value="id"
							:disabled="editApplicant"
							v-model="applicant.gender"
						></v-select>
					</v-flex>
					<v-flex xs2 class="tw-pl-2">
						<label :style="`color:${$appColors.info}; font-weight: bold;`">Estado Civil:</label>
					</v-flex>
					<v-flex xs4>
						<v-select
							solo
							class="custom-select-form-v2"
							:items="civilStatus.data"
							item-text="name"
							item-value="id"
							:disabled="editApplicant"
							v-model="applicant.civilStatusId"
						></v-select>
					</v-flex>
				</v-layout>	
				<v-layout row class="tw-flex tw-justify-between tw-items-center">
					<v-flex xs2>
						<label :style="`color:${$appColors.info}; font-weight: bold;`">Edad:</label>
					</v-flex>
					<v-flex xs4>
						<input
							class="form-applicant-input"
							type="number"
							:disabled="editApplicant"
							v-model="applicant.age">
					</v-flex>
					<v-flex xs2 class="tw-pl-2">
						<label :style="`color:${$appColors.info}; font-weight: bold;`">Fecha de Nacimiento:</label>
					</v-flex>
					<v-flex xs4>
						<app-date-flat
							class="input-text"
							date-format="Y-m-d"
							v-model="applicant.dateBirth"
							:default-date="applicant.dateBirth"
							:enable-time="false"
							:blockFutureDates="true"
							:style="`border-radius:4px; color: ${$appColors.info} !important`"
							@input="changeDate({ model: 'dateBirth', value: $event })"
						></app-date-flat>
					</v-flex>
				</v-layout>
				<v-layout row class="tw-flex tw-justify-between tw-items-center">
					<v-flex xs2>
						<label :style="`color:${$appColors.info}; font-weight: bold;`">Discapacidad:</label>
					</v-flex>
					<v-flex xs4>
						<v-select
							solo
							class="custom-select-form-v2"
							:items="disabilities"
							item-text="name"
							item-value="id"
							:disabled="editApplicant"
							v-model="applicant.disability"
						></v-select>
					</v-flex>
					<v-flex xs2 class="tw-pl-2">
						<label :style="`color:${$appColors.info}; font-weight: bold;`">CV (Link):</label>
					</v-flex>
					<v-flex xs4>
						<input
							class="form-applicant-input"
							type="text"
							v-model="applicant.cv">
					</v-flex>
				</v-layout>
				<v-layout row class="tw-flex tw-justify-between tw-items-center">
					<v-flex xs2>
						<label :style="`color:${$appColors.info}; font-weight: bold;`">Lugar de residencia:</label>
					</v-flex>
					<v-flex xs4>
						<input
							class="form-applicant-input"
							type="text"
							placeholder="Ciudad, Dirección(Sector, Calles)"
							:disabled="editApplicant"
							v-model="applicant.placeOfResidence">
					</v-flex>
					<v-flex xs3 class="tw-pl-2">
						<label :style="`color:${$appColors.info}; font-weight: bold;`">Aspiración Salarial:</label>
					</v-flex>
					<v-flex xs3>
						<input
							class="form-applicant-input"
							type="number"
							:disabled="editApplicant"
							v-model="applicant.salaryExpectation">
					</v-flex>
				</v-layout>
				<v-layout row class="tw-flex tw-justify-start tw-items-center">
					<v-flex xs2>
						<label :style="`color:${$appColors.info}; font-weight: bold;`">Tipo:</label>
					</v-flex>
					<v-flex xs4>
						<v-select
							solo
							class="custom-select-form-v2"
							:items="typeApplicant.data"
							item-text="name"
							item-value="id"
							:disabled="editApplicant"
							v-model="applicant.typeApplicantId"
							return-object
						></v-select>
					</v-flex>
					<v-flex xs2 class="tw-pl-2">
						<label :style="`color:${$appColors.info}; font-weight: bold;`">Estado:</label>
					</v-flex>
					<v-flex xs4>
						<v-checkbox
							:disabled="editApplicant"
							v-model="applicant.status"
							:title="statusApplicant"
							hide-details
							color="success"
							style="background: white"
							class="custom-checkbox"
						>
						</v-checkbox>
					</v-flex>
				</v-layout>
			</section>
			<p-horizontal-divider></p-horizontal-divider>
			<div class="tw-flex tw-justify-center tw-items-center tw-pb-4">
				<p-button
					type="primary"
					:disabled="!isValidated"
					@click="savedNewApplicant"
					> {{textButtonModal}}
				</p-button>
			</div>
		</p-card>
	</v-dialog>
</template>

<script>
import PCard from '@/modules/shared/components/ui/Card/p-card';
import appDateFlat from '@/components/shared/app-date-flat';
import PHorizontalDivider from '@/modules/shared/components/ui/p-horizontal-divider';
import CloseIcon from '@/modules/shared/components/icons/close-icon';
import PButton from '@/modules/shared/components/ui/p-button';
import PHeaderDialog from '@/modules/shared/components/ui/dialog/p-header-dialog';
import loadFile from '@/components/shared/load-image';
import { required } from 'vuelidate/lib/validators';
import { mapState } from 'vuex';
import { pathOr } from 'ramda';
import { format } from 'date-fns';
import helper from '@/shared/helper';

const { calculateYears } = helper;

export default {
	name: 'add-subfactor-dialog',
	beforeCreate() {
	},
	created() {
		this.loadData();
		this.codeCompany = this.$userInfo.company.code;
		this.applicant.urlImage = 'https://praktiko-main.s3.us-east-1.amazonaws.com/iconos/Icons+sidebar/user-null.svg';
	},
	mounted() {},
	data() {
		return {
			isVisible: false,
			applicant: {
				name: '',
				lastName: '',
				typeDocument: null,
				documentNumber: null,
				phone: '',
				email: '',
				gender: null,
				civilStatusId: null,
				dateBirth: null,
				age: null,
				disability: '',
				salaryExpectation: null,
				typeApplicantId: null,
				status: true,
				cv: null,
				urlImage: null,
				placeOfResidence: null,
			},
			gender: [
				{ id: 1, name: 'Masculino' },
				{ id: 2, name: 'Femenino' },
			],
			typeDocuments: [],
			disabilities: [
				{
					id: 'NO',
					name: 'NO',
				},
				{
					id: 'SI',
					name: 'SI',
				},
			],
		};
	},
	components: {
		PHeaderDialog,
		PButton,
		CloseIcon,
		PCard,
		PHorizontalDivider,
		loadFile,
		appDateFlat,
	},
	methods: {
		open() {
			this.isVisible = true;
		},
		close() {
			this.isVisible = false;
		},
		async loadData() {
			try {
				const { data: response } = await this.$httpPraktiko.get('type-documents');
				this.typeDocuments = response;
			} catch (error) {
				this.showGenericError();
			}
		},
		savedNewApplicant() {
			this.$emit('savedNewApplicant', this.applicant);
			this.close();
		},
		getImage(url) {
			this.applicant.urlImage = url;
		},
		changeDate({ model, value }) {
			this.applicant[model] = format(value, 'YYYY-MM-DD');
			this.applicant.age = calculateYears(format(this.applicant[model], 'YYYY-MM-DD'), true);
		},
	},
	computed: {
		...mapState('recruitment', {
			civilStatus: pathOr([], ['dataSelection', 'civilStatus']),
			typeApplicant: pathOr([], ['dataSelection', 'typeApplicant']),
		}),
		isValidated() {
			return (
				this.$v.applicant.name.required &&
				this.$v.applicant.lastName.required &&
				this.$v.applicant.typeDocument.required &&
				this.$v.applicant.documentNumber.required &&
				this.$v.applicant.phone.required &&
				this.$v.applicant.email.required &&
				this.$v.applicant.gender.required &&
				this.$v.applicant.civilStatusId.required &&
				this.$v.applicant.age.required &&
				this.$v.applicant.dateBirth.required &&
				this.$v.applicant.disability.required &&
				this.$v.applicant.placeOfResidence.required &&
				this.$v.applicant.salaryExpectation.required &&
				this.$v.applicant.typeApplicantId.required
			);
		},
		statusApplicant() {
			return this.applicant.status ? 'Deshabilitar' : 'Habilitar';
		},
		validateImage() {
			if (this.applicant.urlImage === 'https://praktiko-main.s3.us-east-1.amazonaws.com/iconos/Icons+sidebar/user-null.svg') {
				return true;
			}
			return false;
		},
		textButtonModal() {
			return this.editApplicant ? 'ACTUALIZAR POSTULANTE' : 'CREAR POSTULANTE';
		},
	},
	validations() {
		return {
			applicant: {
				name: { required },
				lastName: { required },
				typeDocument: { required },
				documentNumber: { required },
				phone: { required },
				email: { required },
				gender: { required },
				civilStatusId: { required },
				age: { required },
				dateBirth: { required },
				disability: { required },
				placeOfResidence: { required },
				salaryExpectation: { required },
				typeApplicantId: { required },
				status: { required },
			},
		};
	},
	props: {
		focusedApplicant: {
			type: Object,
			default: {},
		},
		editApplicant: {
			type: Boolean,
			default: false,
		},
	},
	watch: {
		focusedApplicant: {
			handler(newVal) {
				if (this.editApplicant) {
					const {
						applicant: {
							name, lastName, typeDocument, documentNumber, phoneNumber,
							email, gender, civilStatusId, age, disability, salaryExpectation,
							dateBirth, typeApplicantId, status, cv, urlImage,
							additionalInformation: { placeOfResidence },
						},
						additionalInformation: { typeApplicant },
					} = newVal;
					let statePatch = false;
					if (status === 1) {
						statePatch = true;
					} else {
						statePatch = false;
					}
					this.applicant.name = name;
					this.applicant.lastName = lastName;
					this.applicant.typeDocument = typeDocument;
					this.applicant.documentNumber = documentNumber;
					this.applicant.phone = phoneNumber;
					this.applicant.email = email;
					this.applicant.gender = gender;
					this.applicant.civilStatusId = civilStatusId;
					this.applicant.age = age;
					this.applicant.dateBirth = dateBirth ? format(dateBirth, 'YYYY-MM-DD') : null;
					this.applicant.disability = disability;
					this.applicant.salaryExpectation = salaryExpectation;
					this.applicant.typeApplicantId = typeApplicant.id || typeApplicantId;
					this.applicant.status = statePatch;
					this.applicant.cv = cv;
					this.applicant.urlImage = urlImage || 'https://praktiko-main.s3.us-east-1.amazonaws.com/iconos/Icons+sidebar/user-null.svg';
					this.applicant.placeOfResidence = placeOfResidence;
				} else {
					this.applicant.name = '';
					this.applicant.lastName = '';
					this.applicant.typeDocument = null;
					this.applicant.documentNumber = null;
					this.applicant.phone = '';
					this.applicant.email = '';
					this.applicant.gender = null;
					this.applicant.civilStatusId = null;
					this.applicant.age = null;
					this.applicant.dateBirth = null;
					this.applicant.disability = '';
					this.applicant.salaryExpectation = '';
					this.applicant.typeApplicantId = null;
					this.applicant.status = true;
					this.applicant.cv = '';
					this.applicant.urlImage = 'https://praktiko-main.s3.us-east-1.amazonaws.com/iconos/Icons+sidebar/user-null.svg';
					this.applicant.placeOfResidence = '';
				}
			},
			deep: true,
			immediate: true,
		},
	},
};
</script>

<style lang="scss" scoped>
.form-applicant {
	width: 100%;
	&-input {
		background: map-get($colors, white);
		border: 1px solid map-get($colors, green-dark);
		border-radius: 4px;
		display: block;
		outline: none;
		color: map-get($colors, gray-sidebar);
		padding: 5px 20px;
		width: 100%;

		&::placeholder {
			color: map-get($colors, placeholder);
		}
	}
	.wrapper-user-image {
		width: 90px;
		position: relative;
	}
	.wrapper-user {
		border-radius: 50%;
		height: 90px;
		margin: auto;
		overflow: hidden;
		width: 90px;
	}
}
	.wrapper-camera {
		bottom: -1px;
		position: absolute;
		right: 13px;
	}
</style>


// WEBPACK FOOTER //
// src/modules/recruitment/components/content/add-applicant-dialog.vue